var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinciple9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 108,
    viewBox: "0 0 109 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.4992 49.7216C52.1424 49.7216 50.2207 51.6432 50.2207 54.0001C50.2207 56.3636 52.1424 58.2852 54.4992 58.2852C56.8561 58.2852 58.7777 56.3636 58.7777 54.0001C58.7777 51.6432 56.8561 49.7216 54.4992 49.7216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54.4999 39.3634C46.4318 39.3634 39.8633 45.925 39.8633 54C39.8633 62.0749 46.4316 68.6434 54.4999 68.6434C62.5682 68.6434 69.1366 62.0751 69.1366 54C69.1366 45.9319 62.5682 39.3634 54.4999 39.3634ZM54.4999 62.3028C49.9268 62.3028 46.2042 58.5801 46.2042 54.0002C46.2042 49.4271 49.927 45.7044 54.4999 45.7044C59.0729 45.7044 62.7957 49.4272 62.7957 54.0002C62.7957 58.5801 59.0729 62.3028 54.4999 62.3028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M96.0797 54C96.0797 52.8885 96.9769 51.9913 98.0884 51.9913H108.5C107.462 23.7828 84.7172 1.03701 56.5087 0V10.4049C56.5087 11.5164 55.6115 12.4137 54.5 12.4137C53.3885 12.4137 52.4913 11.5165 52.4913 10.4049V0C24.2828 1.03782 1.53701 23.7828 0.5 51.9913H10.9116C12.0231 51.9913 12.9203 52.8885 12.9203 54C12.9203 55.1115 12.0231 56.0087 10.9116 56.0087H0.5C1.53782 84.2172 24.2828 106.963 52.4913 108V97.5884C52.4913 96.4769 53.3885 95.5797 54.5 95.5797C55.6115 95.5797 56.5087 96.4769 56.5087 97.5884V108C84.7172 106.962 107.463 84.2172 108.5 56.0087H98.0884C96.9836 56.0087 96.0797 55.1115 96.0797 54ZM54.4997 91.7302C33.6959 91.7302 16.7763 74.8037 16.7763 54.0069C16.7763 33.2031 33.6961 16.2835 54.4997 16.2835C75.3032 16.2835 92.223 33.2033 92.223 54.0069C92.223 74.8037 75.3032 91.7302 54.4997 91.7302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M54.5005 20.2943C35.913 20.2943 20.7949 35.413 20.7949 53.9999C20.7949 72.5868 35.9136 87.7054 54.5005 87.7054C73.0874 87.7054 88.206 72.5868 88.206 53.9999C88.206 35.4193 73.0874 20.2943 54.5005 20.2943ZM54.5005 72.661C44.216 72.661 35.8462 64.2915 35.8462 53.9999C35.8462 43.7154 44.2157 35.3456 54.5005 35.3456C64.7852 35.3456 73.1547 43.7151 73.1547 53.9999C73.1547 64.291 64.7852 72.661 54.5005 72.661Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciple9);
export default __webpack_public_path__ + "static/media/principle-9.45c7b102130540bb24cc054e4ffc852a.svg";
export { ForwardRef as ReactComponent };